import React from 'react';
import { useLocation } from 'react-router-dom';

import LayoutPadding from 'core/components/LayoutPadding';
import { ICONS } from 'core/components/Icon';
import { useStickyPosition } from 'core/hooks';

import DesktopNavItem, { BalanceProps } from './DesktopNavItem';
import { MenuItem } from '../../Header.sitecore';
import * as S from './DesktopHeader.style';

interface IProps {
	menuItems: MenuItem[];
	dataTargetRoot?: string;
	showAccountSwitcher: boolean;
	accountSwitcherIcon: ICONS;
	balanceData?: BalanceProps;
}

const DesktopHeader = ({
	menuItems,
	dataTargetRoot = 'desktop--header--nav',
	showAccountSwitcher = false,
	accountSwitcherIcon,
	balanceData,
}: IProps) => {
	const navRef = React.useRef<HTMLElement>(null);
	const { StickyWrapper, isFixedOnTop } = useStickyPosition(navRef);
	const { pathname } = useLocation();

	const activeLevel1MenuItemId = menuItems.find(({ url }) => {
		// extract the level 1 pathname from the current url
		const [level1Pathname] = pathname.match(/(^\/[^\/]*)/) ?? [];

		return url === level1Pathname;
	})?.id;

	return (
		<StickyWrapper
			fallbackHeight={64}
			isFixedOnTop={isFixedOnTop}
			showOrangeBar
		>
			<S.Nav data-target-id={`${dataTargetRoot}`} ref={navRef}>
				<LayoutPadding>
					<S.PrimaryNavList
						showAccountSwitcher={showAccountSwitcher}
						role="menubar"
						aria-label="functions"
					>
						{menuItems.map(menuItem => {
							return (
								<DesktopNavItem
									key={menuItem?.id}
									menuItem={menuItem}
									dataTargetRoot={`${dataTargetRoot}`}
									isActiveNav={activeLevel1MenuItemId === menuItem.id}
									accountSwitcherIcon={accountSwitcherIcon}
									balanceData={balanceData}
								/>
							);
						})}
					</S.PrimaryNavList>
				</LayoutPadding>
			</S.Nav>
		</StickyWrapper>
	);
};

export default DesktopHeader;
